export const COOKIES_GLCC_ACCESS_TOKEN =
  process.env.NEXT_PUBLIC_ENV === "local" ? "glccUserToken" : "glccToken";
// Token native to Glencoco backend. It is used for user impersonation by admin account
export const COOKIES_USE_GLCC_NATIVE_TOKEN = "useGlccNativeToken";
export const COOKIES_GLCC_NATIVE_ACCESS_TOKEN = "glccNativeToken";
